import { render, staticRenderFns } from "./demandIndex.vue?vue&type=template&id=44e15aa0&scoped=true"
import script from "./demandIndex.vue?vue&type=script&lang=js"
export * from "./demandIndex.vue?vue&type=script&lang=js"
import style0 from "./demandIndex.vue?vue&type=style&index=0&id=44e15aa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e15aa0",
  null
  
)

export default component.exports